.icon {
  display: block;
  transition-duration: 0.1s;
  transition-property: fill, stroke;
  flex-shrink: 0;
}

/* Outline glyphs (design-system stroke icons) declare fill="none" and must stay unfilled. */
.icon:not([fill="none"]) {
  fill: currentColor;
}
